import React, { Dispatch, SetStateAction } from 'react';
import styles from './DisciplineCarousel.module.css';
import TextButton from 'shared/components/TextButton/TextButton';

type Props = {
  choosedDiscipline: string | null;
  setChoosedDiscipline: Dispatch<SetStateAction<string>>;
  disciplines: string[] | [];
};

const DisciplineCarousel = ({
  choosedDiscipline = 'all',
  setChoosedDiscipline,
  disciplines,
}: Props) => {
  const names: { [name: string]: string } = {
    all: 'Все',
    math: 'Математика',
    environment: 'Окружающий мир',
    rus: 'Русский язык',
    english: 'Английский язык',
    algebra: 'Алгебра',
    geometry: 'Геометрия',
    biology: 'Биология',
    physics: 'Физика',
  };

  return (
    <div className={styles.wrapper}>
      {disciplines.map((e) => (
        <TextButton
          key={e}
          underscored={choosedDiscipline === e}
          id={e}
          setUnderscored={() => setChoosedDiscipline(e)}
          label={names[e]}
        />
      ))}
    </div>
  );
};

export default DisciplineCarousel;
